/**
 * Background from tez vs competitor minimum prices (PHP report parity).
 * delta = tezPrice - operatorPrice
 */
export function getPriceDeltaCellBackground(
  tezPrice: number,
  operatorPrice: number,
): string | undefined {
  const delta = tezPrice - operatorPrice;

  if (delta > 150) {
    return "#b50e04";
  }
  if (delta > 110) {
    return "#d93329";
  }
  if (delta > 80) {
    return "#ff7777";
  }
  if (delta > 50) {
    return "#ff9999";
  }
  if (delta > 20) {
    return "#ffbbbb";
  }
  if (delta >= 0) {
    return "#ffdddd";
  }
  if (delta <= -150) {
    return "#267523";
  }
  if (delta < -110) {
    return "#349c30";
  }
  if (delta < -80) {
    return "#53bd4f";
  }
  if (delta < -50) {
    return "#87d984";
  }
  if (delta < -20) {
    return "#b7f5b5";
  }

  return undefined;
}
